import { module } from 'modujs';

export default class extends module {
    constructor(m) {
        super(m);
    }

    init() {
        this.isInviewArr = [] 
        this.$navItems = this.$('item')
    }

    changeState(e) {
        const way = e.way
        const index = Array.from(e.obj.target.parentNode.children).indexOf(e.obj.target)

        if (way === 'enter') {
            this.isInviewArr.push(index)
        } else if (way === 'exit') {
            const position = this.isInviewArr.indexOf(index)
            if (position > -1) {
                this.isInviewArr.splice(position, 1);
            }
        }

        if (this.isInviewArr.length) {
            this.highlightNavItem(Math.min(...this.isInviewArr))
        }
    }

    highlightNavItem(activeIndex) { 
        let index = 0;
        while (index < this.$navItems.length) {
            const $navItem = this.$navItems[index]
            $navItem.classList.remove('is-active')
            index++
        }

        const $activeElement = this.$navItems[activeIndex]
        if ($activeElement) {
            $activeElement.classList.add('is-active')
        }
    }
}
